import { addModuleStyles } from '@glu/theming/glu-css-override';
import hexToRgb from './hexToRgb';

const toRgba = (hexCode, opacity) => (
  hexCode[0] === '#' ?
    `rgba(${hexToRgb(hexCode).join(', ')}, ${opacity})` :
    hexCode
);

const defaultTheme = ({ legacy, palette }) => (legacy ? null : {
  backgroundColor: palette.background,
  hoverBackgroundColor: palette.highlightBackground,
  borderColor: palette.accent,
  borderWidth: 4,
  rowHeight: 50,
  actionHoverBackground: palette.primary.normal,
  actionHoverColor: palette.text.light,
  actionColor: palette.primary.normal,
  actionBackground: 'transparent',
  footerOpacity: 0.9,
  activeSortBackground: 'transparent',
  tableFooterShadow: '0px -2px 3px rgba(0,0,0,0.2)',
  checkboxCheckedBackground: palette.primary.darkBackground,
  checkboxBorder: palette.grey.G600
});

const styles = ({ legacyGrid }) => (legacyGrid ? {
  root: {
    '& .grid': {
      '& section.content': {
        border: 'none'
      },

      '& .table > thead': {
        backgroundColor: legacyGrid.backgroundColor,

        '& > tr > th': {
          border: 'none'
        },

        '& .txt': {
          fontWeight: 'normal',
          textTransform: 'uppercase'
        }
      },

      '& .table > tbody': {
        borderTop: `${legacyGrid.borderWidth}px solid ${legacyGrid.borderColor}`,
        borderBottom: 'none',

        '& > tr': {
          height: legacyGrid.rowHeight,
          backgroundColor: legacyGrid.backgroundColor,

          '&:hover': {
            backgroundColor: legacyGrid.hoverBackgroundColor
          },

          '& > td': {
            height: legacyGrid.rowHeight,
            verticalAlign: 'middle',
            lineHeight: 1,
            padding: '11px 20px',
            borderTop: 'none',

            '&:first-child': {
              borderLeft: 'none'
            },

            '&:last-child': {
              borderRight: 'none'
            },

            '&.grid-row-buttons > button': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '100%'
            }
          }
        }
      },
      '& .grid-row-buttons .dropdown-toggle': {
        fill: legacyGrid.actionColor,
        backgroundColor: legacyGrid.actionBackground,
        transition: 'all 0.3s ease-in-out',
        padding: 5,
        height: 34,

        '& svg': {
          fill: legacyGrid.actionColor,
          height: 24,
          width: 24
        },

        '&:hover, &:focus': {
          backgroundColor: legacyGrid.actionHoverBackground,

          '& svg': {
            fill: legacyGrid.actionHoverColor
          }
        }
      },
      '& .footer': {
        position: 'relative',
        marginTop: legacyGrid.borderWidth
      },
      '& .footer > *:first-child::before': {
        boxShadow: legacyGrid.tableFooterShadow,
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        height: legacyGrid.borderWidth
      },
      '& .footer, & .bulk-actions, & .footer .pager': {
        backgroundColor: toRgba(legacyGrid.backgroundColor, legacyGrid.footerOpacity)
      },
      '& .sticky-footer': {
        borderTop: 'none'
      },
      '& .footer .pager .paginate-advanced  .navigate': {
        '& .grid-page-size-controls, & .grid-pagination-controls': {
          '& nav, & .paginate-page-select, & .paginate-page-size': {
            display: 'flex',
            alignItems: 'center',

            '& > *': {
              paddingRight: 3,
              paddingBottom: 0,
              lineHeight: 1,

              '&:last-child': {
                paddingRight: 0
              }
            }
          }
        }
      },
      '& .table > thead > tr > th[aria-sort]:not(:hover)': {
        backgroundColor: legacyGrid.activeSortBackground
      },

      '& input[type="checkbox"]:focus + label::before': {
        border: '2px solid #a1c3fa'
      },

      '& .grid-row, & .grid-row-selector': {
        '& input': {
          width: 16,
          height: 16,
          opacity: 0,
          position: 'absolute'
        },
        '& label': {
          position: 'relative',
          marginBottom: 0,
          fontSize: 0
        },
        '& input:checked + label::before': {
          backgroundColor: legacyGrid.checkboxCheckedBackground
        },
        '& .pseudoCheckbox': {
          width: 16,
          height: 16,
          marginTop: -16,
          border: `1px solid ${legacyGrid.checkboxBorder}`,
          display: 'block',
          borderRadius: 2,
          backgroundColor: '#fff',
          position: 'relative',
          pointerEvents: 'none'
        },
        '& .pseudoCheckbox::after': {
          content: '""'
        },
        '& input[type="checkbox"]:checked ~ .pseudoCheckbox': {
          backgroundColor: legacyGrid.checkboxCheckedBackground,
          '&::after': {
            content: '""',
            top: 0,
            left: 5,
            width: 5,
            height: 10,
            border: 'solid #fff',
            position: 'absolute',
            transform: 'rotate(45deg)',
            borderWidth: '0 1px 1px 0'
          }
        }
      },

      '& .grid-pagination-controls .btn': {
        height: 'auto'
      }
    }
  }
} : {});

addModuleStyles(styles, 'legacyGrid', defaultTheme);
